export const useEmbed = () => {
  const embed = useState('embed', () => false);
  if (import.meta.client && !embed.value) {
    const flagged = useRoute().query.embed === '1' || window.sessionStorage.getItem('envelope-embed') === '1';
    if (flagged) {
      embed.value = true;
      window.sessionStorage.setItem('envelope-embed', '1');
    }
  }
  return embed;
};

export const useEmbedAuthFailed = () => useState('embed-auth-failed', () => false);

export const useEmbedParentOrigin = () => {
  if (!import.meta.client || !document.referrer) return null;
  try {
    return new URL(document.referrer).origin;
  } catch {
    return null;
  }
};

export const useEmbedReferenceId = () => {
  const refId = useState('embed-reference-id', () => null);
  if (import.meta.client && !refId.value) {
    const fromUrl = useRoute().query.referenceId;
    if (typeof fromUrl === 'string' && fromUrl) {
      refId.value = fromUrl;
    }
  }
  return refId;
};

export const useEmbedPromptSuccess = () => useState('embed-prompt-success', () => null);

export const useEmbedElementVisibility = (key) => computed(() => {
  if (!useEmbed().value) return true;
  const v = useRoute().query[key];
  return v !== '0' && v !== 'false';
});
